"use strict";

/**
 * "Binary button" interaction showing a series of views with question text and two labelled 
 * buttons.
 */

import MultiItemInteractionView from "/js/interaction-views/multi-item-interaction-view.js"
import BinaryButtonItemView from "/js/interaction-views/binary-button-item-view.js";

export default class BinaryButtonInteractionView extends MultiItemInteractionView {
  initContent() {
    const numItems = this.data.questions.length;
    this.data.questions.forEach(function(questionObject, index) {
      const item = new BinaryButtonItemView(questionObject, index, numItems);
      this.$el.append(item.$el);
      this.items.push(item);
    }, this);
  }
}
